module.exports = function getResource(label, vars = []) {
    let resources = {
        liveChat: 'Clavardage en direct'
    };

    return resources[label];
};
